import React from 'react';

const ResetTimerModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[61]'>

          <div className='bg-white rounded-lg p-4 max-w-sm w-full'>
            <h2 className='text-lg font-bold mb-4 text-center font-montserrat'>{message}</h2>
            <div className='flex justify-center gap-4 items-center'>
              <button
                onClick={onConfirm}
                className='bg-primary text-white px-4 py-2 rounded font-bebas'>
                Confirm
              </button>
              <button
                onClick={onClose}
                className='bg-black text-white px-4 py-2 rounded font-bebas'>
                Cancel
              </button>
            </div>
          </div>

    </div>
  );
};

export default ResetTimerModal;